import { render, staticRenderFns } from "./ProgramStatItem.vue?vue&type=template&id=7bdd3b90&scoped=true&"
import script from "./ProgramStatItem.vue?vue&type=script&lang=js&"
export * from "./ProgramStatItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStatItem.vue?vue&type=style&index=0&id=7bdd3b90&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdd3b90",
  null
  
)

export default component.exports